import styled from "styled-components";

import { ExternalLink } from "../../../../ui/Link";
import { FBPageExtended } from "../../../../api/social-account-connect/facebook";

import { GetConnectButtonState } from "../connect-button";
import { AccountList } from "../account-list";

interface FacebookPageListProps {
  className?: string;
  pages: FBPageExtended[];
  onConnect(acc: FBPageExtended): void;
  getConnectButtonState: GetConnectButtonState<FBPageExtended>;
}

export function FacebookPageList({
  className,
  pages,
  onConnect,
  getConnectButtonState,
}: FacebookPageListProps) {
  return (
    <Root className={className}>
      <h4>Select the Pages you'd like to add to Sked Social:</h4>
      <AccountList
        items={pages}
        getConnectButtonState={getConnectButtonState}
        renderItemLabel={(page) => {
          const idLink = (
            <ExternalLink href={`https://facebook.com/${page.id}`}>
              {page.id}
            </ExternalLink>
          );
          return page.name ? (
            <>
              {page.name} ({idLink})
            </>
          ) : (
            idLink
          );
        }}
        onConnect={onConnect}
      />
      <p className="font-inter text-sm text-neutral-900">
        Missing a Page or Instagram account? Open{" "}
        <ExternalLink href="https://www.facebook.com/settings?tab=business_tools">
          Business integrations on Facebook
        </ExternalLink>
        , choose "View and edit" next to Sked Social, tick what's missing, then
        Save and connect again.
      </p>
    </Root>
  );
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 8px;

  & > * {
    margin: 0;
  }
`;
